import { cn } from "@bcc/lib/utils";
import { CountryFlag } from "./CountryFlag";

interface ShipToFlagIconDisplayProps {
  /** Country codes to render as flags, in order. */
  countryCodes: string[];
  /** Diameter of each flag in pixels. Defaults to CountryFlag's own default (20). */
  size?: number;
  /** Accessible name for the whole flag group (e.g. "Ships to Germany, Netherlands"). Required — see Accessibility. */
  ariaLabel: string;
  className?: string;
  testId?: string;
  /** Per-flag test id, e.g. (code) => setShipToFlagTestId(rowIndex, code). Optional — flags render without a testId if omitted. */
  getFlagTestId?: (countryCode: string) => string;
}

export const ShipToFlagIconDisplay = ({ countryCodes, size, ariaLabel, className, testId, getFlagTestId }: ShipToFlagIconDisplayProps) => (
  // Spans, not divs — this can render inside a PopoverTrigger, which Radix renders as a <button>,
  // and a div isn't valid phrasing content there.
  <span role="img" aria-label={ariaLabel} data-testid={testId} className={cn("inline-flex items-center", className)}>
    <span aria-hidden="true" className="inline-flex items-center">
      {countryCodes.map((countryCode) => (
        <CountryFlag
          key={countryCode}
          countryCode={countryCode}
          size={size}
          className="-ml-1.5 ring-2 ring-background first:ml-0"
          testId={getFlagTestId?.(countryCode)}
        />
      ))}
    </span>
  </span>
);
